import TextBoxSelection from "components/basic/textBoxSelection/textBoxSelectionList";
import TextField from "components/basic/textField";

export interface TextBoxSelectionWithPriceAndNameProps {
  label?: string;
  checked: boolean;
  onSelectionChange: (checked: boolean) => void;
  price?: number;
  onPriceChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  placeHolder?: string;
}

export const TextBoxSelectionWithPriceAndName: React.FC<
  TextBoxSelectionWithPriceAndNameProps
> = ({
  label,
  placeHolder = "Enter Value",
  checked,
  onSelectionChange,
  onPriceChange,
  disabled,
  price,
  name,
  onNameChange,
}) => {
  return (
    <div>
      <TextBoxSelection
        label={label}
        checked={checked}
        onChange={onSelectionChange}
        disabled={disabled}
      >
        <TextField
          style={{ marginTop: 8 }}
          placeHolder={placeHolder}
          name={label ?? ""}
          type="text"
          value={name}
          onChange={onNameChange}
        />

        <TextField
          startAdornment={<>$</>}
          style={{ marginTop: 8 }}
          placeHolder="enter price in CAD"
          name={label ?? ""}
          type="text"
          step={5}
          value={price}
          onChange={onPriceChange}
        />
      </TextBoxSelection>
    </div>
  );
};
